"use client";

import React from "react";
import { Box } from "@mui/material";
import ReactHtmlParser from "@/src/utils/html-parser";

type WidgetProps = {
  value: any;
};

const CardWidget: React.FC<WidgetProps> = ({ value }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        width: "100%",
        pt: 0.75,
        borderTop: "1px solid",
        borderColor: "custom.ruleHairline",
        "& a": { textDecoration: "none", color: "custom.link" },
        "& p": { marginY: 0.25, fontSize: "0.8125rem" },
        "& img": { maxWidth: "100%", height: "auto" },
      }}
    >
      {ReactHtmlParser(value?.content)}
    </Box>
  );
};

export default CardWidget;
